module.exports = __webpack_public_path__ + "img/advisor-item-bg@2x.289436f8.png";